import { render, staticRenderFns } from "./chatInfo.vue?vue&type=template&id=0a31773b&scoped=true&"
import script from "./chatInfo.vue?vue&type=script&lang=js&"
export * from "./chatInfo.vue?vue&type=script&lang=js&"
import style0 from "./chatInfo.vue?vue&type=style&index=0&id=0a31773b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a31773b",
  null
  
)

export default component.exports